<div class="flex flex-col h-full" id="get-gbp-updates">

  <div mat-dialog-title class="flex flex-row items-center
                               pt-6 pl-6 pr-6 pb-4 m-[unset]">
    <div class="flex flex-row justify-center items-center
                      w-[40px] h-[40px] rounded-[8px]
                      bg-green-90 text-green-10">
      <mat-icon svgIcon="get_gmb_updates"></mat-icon>
    </div>
    <span class="ml-4 text-neutral-10 text-title-large">Get GBP updates</span>
  </div>

  <mat-dialog-content class="m-[unset] pb-[24px] flex flex-col">

    <mat-checkbox class="h-[32px]" [checked]="allSelected"
      [indeterminate]="someSelected()"
      (change)="onMasterToggleClicked($event.checked)">Select all
    </mat-checkbox>

    <mat-divider class="m-[4px]"></mat-divider>

    @for (item of selection; track item) {
      <mat-checkbox [(ngModel)]="item.selected"
        (ngModelChange)="updateMasterToggleState()" class="h-[32px]">
        {{item.displayedText}}
      </mat-checkbox>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="justify-end min-h-[unset]
                             mb-0 pb-6 pl-6 pr-6 pt-0">
    <button matButton="outlined" mat-dialog-close tabindex="-1">Cancel</button>
    <button mat-flat-button [mat-dialog-close]="generateResult()" color="primary" tabindex="-1"
      class="flex flex-row items-center justify-center h-[36px]"
      [disabled]="nothingSelected()">
      Get GBP updates
    </button>
  </mat-dialog-actions>

</div>
